/**
 * @generated SignedSource<<05fb54035b7a7510632889b0b05f1213>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedMeetTheSeller_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedContactSellerButton_item">;
  readonly " $fragmentType": "PdpSharedMeetTheSeller_item";
};
export type PdpSharedMeetTheSeller_item$key = {
  readonly " $data"?: PdpSharedMeetTheSeller_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedMeetTheSeller_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedMeetTheSeller_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactSellerButton_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "f450bd2e0a268da281036be05cb73737";

export default node;
